module.exports = __webpack_public_path__ + "img/k.7aab1fed.jpg";